// extracted by mini-css-extract-plugin
export default {"sparkChartContainer":"SparkChart_sparkChartContainer__DFd7w","sparkChartDomElement":"SparkChart_sparkChartDomElement__v6jFk"};